import React from 'react';
import { useTranslation } from 'react-i18next';

import CollapsedMessage from '../../../../components/collapsed-message/CollapsedMessage';
import CardMark from '../../../../scout-new/components/message-card/CardMark';

import scss from './Navig8Messages.module.scss';

function Navig8MessageCard({ count, message, isNew, type }) {
  const { t } = useTranslation('sonar');

  return (
    <li className={scss.cardWrapper}>
      <div className={scss.idCell}>{count}</div>

      <CollapsedMessage>
        <div className={scss.messageWrapper}>
          <span className={scss.type}>{t(type)}</span>
          <span>{message}</span>
        </div>
      </CollapsedMessage>

      <CardMark isNew={isNew} />
    </li>
  );
}

export default Navig8MessageCard;
